// Protocol Buffers for Search Services
// 
// Package: guardianai.v1.search

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/search/search.proto (package guardianai.v1.search, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/search/search.proto.
 */
export const file_guardianai_v1_search_search: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message guardianai.v1.search.SearchRequest
 */
export type SearchRequest = Message<"guardianai.v1.search.SearchRequest"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * "user", "fraud_report", "evidence", "gig"
   *
   * @generated from field: repeated string entity_types = 2;
   */
  entityTypes: string[];

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 4;
   */
  offset: number;

  /**
   * @generated from field: map<string, string> filters = 5;
   */
  filters: { [key: string]: string };

  /**
   * @generated from field: string sort_by = 6;
   */
  sortBy: string;

  /**
   * @generated from field: string sort_order = 7;
   */
  sortOrder: string;
};

/**
 * @generated from message guardianai.v1.search.SearchRequest
 */
export type SearchRequestJson = {
  /**
   * @generated from field: string query = 1;
   */
  query?: string;

  /**
   * "user", "fraud_report", "evidence", "gig"
   *
   * @generated from field: repeated string entity_types = 2;
   */
  entityTypes?: string[];

  /**
   * @generated from field: int32 limit = 3;
   */
  limit?: number;

  /**
   * @generated from field: int32 offset = 4;
   */
  offset?: number;

  /**
   * @generated from field: map<string, string> filters = 5;
   */
  filters?: { [key: string]: string };

  /**
   * @generated from field: string sort_by = 6;
   */
  sortBy?: string;

  /**
   * @generated from field: string sort_order = 7;
   */
  sortOrder?: string;
};

/**
 * Describes the message guardianai.v1.search.SearchRequest.
 * Use `create(SearchRequestSchema)` to create a new message.
 */
export const SearchRequestSchema: GenMessage<SearchRequest, {jsonType: SearchRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_search_search, 0);

/**
 * @generated from message guardianai.v1.search.SearchResponse
 */
export type SearchResponse = Message<"guardianai.v1.search.SearchResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.search.SearchResult results = 1;
   */
  results: SearchResult[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;

  /**
   * counts by entity type
   *
   * @generated from field: map<string, int32> facets = 3;
   */
  facets: { [key: string]: number };
};

/**
 * @generated from message guardianai.v1.search.SearchResponse
 */
export type SearchResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.search.SearchResult results = 1;
   */
  results?: SearchResultJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;

  /**
   * counts by entity type
   *
   * @generated from field: map<string, int32> facets = 3;
   */
  facets?: { [key: string]: number };
};

/**
 * Describes the message guardianai.v1.search.SearchResponse.
 * Use `create(SearchResponseSchema)` to create a new message.
 */
export const SearchResponseSchema: GenMessage<SearchResponse, {jsonType: SearchResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_search_search, 1);

/**
 * @generated from message guardianai.v1.search.SearchResult
 */
export type SearchResult = Message<"guardianai.v1.search.SearchResult"> & {
  /**
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * @generated from field: string entity_id = 2;
   */
  entityId: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: double relevance_score = 5;
   */
  relevanceScore: number;

  /**
   * @generated from field: map<string, string> metadata = 6;
   */
  metadata: { [key: string]: string };

  /**
   * @generated from field: repeated string highlights = 7;
   */
  highlights: string[];

  /**
   * Additional fields for frontend compatibility
   *
   * Alias for title
   *
   * @generated from field: string name = 8;
   */
  name: string;

  /**
   * @generated from field: double trust_score = 9;
   */
  trustScore: number;

  /**
   * @generated from field: string status = 10;
   */
  status: string;
};

/**
 * @generated from message guardianai.v1.search.SearchResult
 */
export type SearchResultJson = {
  /**
   * @generated from field: string entity_type = 1;
   */
  entityType?: string;

  /**
   * @generated from field: string entity_id = 2;
   */
  entityId?: string;

  /**
   * @generated from field: string title = 3;
   */
  title?: string;

  /**
   * @generated from field: string description = 4;
   */
  description?: string;

  /**
   * @generated from field: double relevance_score = 5;
   */
  relevanceScore?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: map<string, string> metadata = 6;
   */
  metadata?: { [key: string]: string };

  /**
   * @generated from field: repeated string highlights = 7;
   */
  highlights?: string[];

  /**
   * Additional fields for frontend compatibility
   *
   * Alias for title
   *
   * @generated from field: string name = 8;
   */
  name?: string;

  /**
   * @generated from field: double trust_score = 9;
   */
  trustScore?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: string status = 10;
   */
  status?: string;
};

/**
 * Describes the message guardianai.v1.search.SearchResult.
 * Use `create(SearchResultSchema)` to create a new message.
 */
export const SearchResultSchema: GenMessage<SearchResult, {jsonType: SearchResultJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_search_search, 2);

/**
 * @generated from message guardianai.v1.search.SearchUsersRequest
 */
export type SearchUsersRequest = Message<"guardianai.v1.search.SearchUsersRequest"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * @generated from field: string role_filter = 2;
   */
  roleFilter: string;

  /**
   * @generated from field: string status_filter = 3;
   */
  statusFilter: string;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 5;
   */
  offset: number;
};

/**
 * @generated from message guardianai.v1.search.SearchUsersRequest
 */
export type SearchUsersRequestJson = {
  /**
   * @generated from field: string query = 1;
   */
  query?: string;

  /**
   * @generated from field: string role_filter = 2;
   */
  roleFilter?: string;

  /**
   * @generated from field: string status_filter = 3;
   */
  statusFilter?: string;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit?: number;

  /**
   * @generated from field: int32 offset = 5;
   */
  offset?: number;
};

/**
 * Describes the message guardianai.v1.search.SearchUsersRequest.
 * Use `create(SearchUsersRequestSchema)` to create a new message.
 */
export const SearchUsersRequestSchema: GenMessage<SearchUsersRequest, {jsonType: SearchUsersRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_search_search, 3);

/**
 * @generated from message guardianai.v1.search.SearchUsersResponse
 */
export type SearchUsersResponse = Message<"guardianai.v1.search.SearchUsersResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.search.UserSearchResult users = 1;
   */
  users: UserSearchResult[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.search.SearchUsersResponse
 */
export type SearchUsersResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.search.UserSearchResult users = 1;
   */
  users?: UserSearchResultJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.search.SearchUsersResponse.
 * Use `create(SearchUsersResponseSchema)` to create a new message.
 */
export const SearchUsersResponseSchema: GenMessage<SearchUsersResponse, {jsonType: SearchUsersResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_search_search, 4);

/**
 * @generated from message guardianai.v1.search.UserSearchResult
 */
export type UserSearchResult = Message<"guardianai.v1.search.UserSearchResult"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string display_name = 3;
   */
  displayName: string;

  /**
   * @generated from field: string role = 4;
   */
  role: string;

  /**
   * @generated from field: string status = 5;
   */
  status: string;

  /**
   * @generated from field: double trust_score = 6;
   */
  trustScore: number;

  /**
   * @generated from field: int64 created_at = 7;
   */
  createdAt: bigint;
};

/**
 * @generated from message guardianai.v1.search.UserSearchResult
 */
export type UserSearchResultJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string email = 2;
   */
  email?: string;

  /**
   * @generated from field: string display_name = 3;
   */
  displayName?: string;

  /**
   * @generated from field: string role = 4;
   */
  role?: string;

  /**
   * @generated from field: string status = 5;
   */
  status?: string;

  /**
   * @generated from field: double trust_score = 6;
   */
  trustScore?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: int64 created_at = 7;
   */
  createdAt?: string;
};

/**
 * Describes the message guardianai.v1.search.UserSearchResult.
 * Use `create(UserSearchResultSchema)` to create a new message.
 */
export const UserSearchResultSchema: GenMessage<UserSearchResult, {jsonType: UserSearchResultJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_search_search, 5);

/**
 * @generated from message guardianai.v1.search.SearchFraudReportsRequest
 */
export type SearchFraudReportsRequest = Message<"guardianai.v1.search.SearchFraudReportsRequest"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * @generated from field: string status_filter = 2;
   */
  statusFilter: string;

  /**
   * @generated from field: string fraud_type_filter = 3;
   */
  fraudTypeFilter: string;

  /**
   * @generated from field: int64 from_date = 4;
   */
  fromDate: bigint;

  /**
   * @generated from field: int64 to_date = 5;
   */
  toDate: bigint;

  /**
   * @generated from field: int32 limit = 6;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 7;
   */
  offset: number;
};

/**
 * @generated from message guardianai.v1.search.SearchFraudReportsRequest
 */
export type SearchFraudReportsRequestJson = {
  /**
   * @generated from field: string query = 1;
   */
  query?: string;

  /**
   * @generated from field: string status_filter = 2;
   */
  statusFilter?: string;

  /**
   * @generated from field: string fraud_type_filter = 3;
   */
  fraudTypeFilter?: string;

  /**
   * @generated from field: int64 from_date = 4;
   */
  fromDate?: string;

  /**
   * @generated from field: int64 to_date = 5;
   */
  toDate?: string;

  /**
   * @generated from field: int32 limit = 6;
   */
  limit?: number;

  /**
   * @generated from field: int32 offset = 7;
   */
  offset?: number;
};

/**
 * Describes the message guardianai.v1.search.SearchFraudReportsRequest.
 * Use `create(SearchFraudReportsRequestSchema)` to create a new message.
 */
export const SearchFraudReportsRequestSchema: GenMessage<SearchFraudReportsRequest, {jsonType: SearchFraudReportsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_search_search, 6);

/**
 * @generated from message guardianai.v1.search.SearchFraudReportsResponse
 */
export type SearchFraudReportsResponse = Message<"guardianai.v1.search.SearchFraudReportsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.search.FraudReportSearchResult reports = 1;
   */
  reports: FraudReportSearchResult[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.search.SearchFraudReportsResponse
 */
export type SearchFraudReportsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.search.FraudReportSearchResult reports = 1;
   */
  reports?: FraudReportSearchResultJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.search.SearchFraudReportsResponse.
 * Use `create(SearchFraudReportsResponseSchema)` to create a new message.
 */
export const SearchFraudReportsResponseSchema: GenMessage<SearchFraudReportsResponse, {jsonType: SearchFraudReportsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_search_search, 7);

/**
 * @generated from message guardianai.v1.search.FraudReportSearchResult
 */
export type FraudReportSearchResult = Message<"guardianai.v1.search.FraudReportSearchResult"> & {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string fraud_type = 3;
   */
  fraudType: string;

  /**
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * @generated from field: string reporter_id = 5;
   */
  reporterId: string;

  /**
   * @generated from field: int64 created_at = 6;
   */
  createdAt: bigint;

  /**
   * @generated from field: repeated string highlights = 7;
   */
  highlights: string[];
};

/**
 * @generated from message guardianai.v1.search.FraudReportSearchResult
 */
export type FraudReportSearchResultJson = {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId?: string;

  /**
   * @generated from field: string title = 2;
   */
  title?: string;

  /**
   * @generated from field: string fraud_type = 3;
   */
  fraudType?: string;

  /**
   * @generated from field: string status = 4;
   */
  status?: string;

  /**
   * @generated from field: string reporter_id = 5;
   */
  reporterId?: string;

  /**
   * @generated from field: int64 created_at = 6;
   */
  createdAt?: string;

  /**
   * @generated from field: repeated string highlights = 7;
   */
  highlights?: string[];
};

/**
 * Describes the message guardianai.v1.search.FraudReportSearchResult.
 * Use `create(FraudReportSearchResultSchema)` to create a new message.
 */
export const FraudReportSearchResultSchema: GenMessage<FraudReportSearchResult, {jsonType: FraudReportSearchResultJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_search_search, 8);

/**
 * @generated from message guardianai.v1.search.SearchEvidenceRequest
 */
export type SearchEvidenceRequest = Message<"guardianai.v1.search.SearchEvidenceRequest"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * @generated from field: string status_filter = 2;
   */
  statusFilter: string;

  /**
   * @generated from field: string category_filter = 3;
   */
  categoryFilter: string;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 5;
   */
  offset: number;
};

/**
 * @generated from message guardianai.v1.search.SearchEvidenceRequest
 */
export type SearchEvidenceRequestJson = {
  /**
   * @generated from field: string query = 1;
   */
  query?: string;

  /**
   * @generated from field: string status_filter = 2;
   */
  statusFilter?: string;

  /**
   * @generated from field: string category_filter = 3;
   */
  categoryFilter?: string;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit?: number;

  /**
   * @generated from field: int32 offset = 5;
   */
  offset?: number;
};

/**
 * Describes the message guardianai.v1.search.SearchEvidenceRequest.
 * Use `create(SearchEvidenceRequestSchema)` to create a new message.
 */
export const SearchEvidenceRequestSchema: GenMessage<SearchEvidenceRequest, {jsonType: SearchEvidenceRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_search_search, 9);

/**
 * @generated from message guardianai.v1.search.SearchEvidenceResponse
 */
export type SearchEvidenceResponse = Message<"guardianai.v1.search.SearchEvidenceResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.search.EvidenceSearchResult evidence = 1;
   */
  evidence: EvidenceSearchResult[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.search.SearchEvidenceResponse
 */
export type SearchEvidenceResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.search.EvidenceSearchResult evidence = 1;
   */
  evidence?: EvidenceSearchResultJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.search.SearchEvidenceResponse.
 * Use `create(SearchEvidenceResponseSchema)` to create a new message.
 */
export const SearchEvidenceResponseSchema: GenMessage<SearchEvidenceResponse, {jsonType: SearchEvidenceResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_search_search, 10);

/**
 * @generated from message guardianai.v1.search.EvidenceSearchResult
 */
export type EvidenceSearchResult = Message<"guardianai.v1.search.EvidenceSearchResult"> & {
  /**
   * @generated from field: string evidence_id = 1;
   */
  evidenceId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string category = 3;
   */
  category: string;

  /**
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * @generated from field: string submitter_id = 5;
   */
  submitterId: string;

  /**
   * @generated from field: int64 submitted_at = 6;
   */
  submittedAt: bigint;

  /**
   * @generated from field: repeated string highlights = 7;
   */
  highlights: string[];
};

/**
 * @generated from message guardianai.v1.search.EvidenceSearchResult
 */
export type EvidenceSearchResultJson = {
  /**
   * @generated from field: string evidence_id = 1;
   */
  evidenceId?: string;

  /**
   * @generated from field: string title = 2;
   */
  title?: string;

  /**
   * @generated from field: string category = 3;
   */
  category?: string;

  /**
   * @generated from field: string status = 4;
   */
  status?: string;

  /**
   * @generated from field: string submitter_id = 5;
   */
  submitterId?: string;

  /**
   * @generated from field: int64 submitted_at = 6;
   */
  submittedAt?: string;

  /**
   * @generated from field: repeated string highlights = 7;
   */
  highlights?: string[];
};

/**
 * Describes the message guardianai.v1.search.EvidenceSearchResult.
 * Use `create(EvidenceSearchResultSchema)` to create a new message.
 */
export const EvidenceSearchResultSchema: GenMessage<EvidenceSearchResult, {jsonType: EvidenceSearchResultJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_search_search, 11);

/**
 * @generated from message guardianai.v1.search.SuggestionRequest
 */
export type SuggestionRequest = Message<"guardianai.v1.search.SuggestionRequest"> & {
  /**
   * @generated from field: string prefix = 1;
   */
  prefix: string;

  /**
   * @generated from field: string entity_type = 2;
   */
  entityType: string;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.search.SuggestionRequest
 */
export type SuggestionRequestJson = {
  /**
   * @generated from field: string prefix = 1;
   */
  prefix?: string;

  /**
   * @generated from field: string entity_type = 2;
   */
  entityType?: string;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.search.SuggestionRequest.
 * Use `create(SuggestionRequestSchema)` to create a new message.
 */
export const SuggestionRequestSchema: GenMessage<SuggestionRequest, {jsonType: SuggestionRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_search_search, 12);

/**
 * @generated from message guardianai.v1.search.SuggestionResponse
 */
export type SuggestionResponse = Message<"guardianai.v1.search.SuggestionResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.search.Suggestion suggestions = 1;
   */
  suggestions: Suggestion[];
};

/**
 * @generated from message guardianai.v1.search.SuggestionResponse
 */
export type SuggestionResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.search.Suggestion suggestions = 1;
   */
  suggestions?: SuggestionJson[];
};

/**
 * Describes the message guardianai.v1.search.SuggestionResponse.
 * Use `create(SuggestionResponseSchema)` to create a new message.
 */
export const SuggestionResponseSchema: GenMessage<SuggestionResponse, {jsonType: SuggestionResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_search_search, 13);

/**
 * @generated from message guardianai.v1.search.Suggestion
 */
export type Suggestion = Message<"guardianai.v1.search.Suggestion"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * @generated from field: string entity_type = 2;
   */
  entityType: string;

  /**
   * @generated from field: int64 usage_count = 3;
   */
  usageCount: bigint;
};

/**
 * @generated from message guardianai.v1.search.Suggestion
 */
export type SuggestionJson = {
  /**
   * @generated from field: string text = 1;
   */
  text?: string;

  /**
   * @generated from field: string entity_type = 2;
   */
  entityType?: string;

  /**
   * @generated from field: int64 usage_count = 3;
   */
  usageCount?: string;
};

/**
 * Describes the message guardianai.v1.search.Suggestion.
 * Use `create(SuggestionSchema)` to create a new message.
 */
export const SuggestionSchema: GenMessage<Suggestion, {jsonType: SuggestionJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_search_search, 14);

/**
 * @generated from message guardianai.v1.search.RecentSearchesRequest
 */
export type RecentSearchesRequest = Message<"guardianai.v1.search.RecentSearchesRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.search.RecentSearchesRequest
 */
export type RecentSearchesRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.search.RecentSearchesRequest.
 * Use `create(RecentSearchesRequestSchema)` to create a new message.
 */
export const RecentSearchesRequestSchema: GenMessage<RecentSearchesRequest, {jsonType: RecentSearchesRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_search_search, 15);

/**
 * @generated from message guardianai.v1.search.RecentSearchesResponse
 */
export type RecentSearchesResponse = Message<"guardianai.v1.search.RecentSearchesResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.search.RecentSearch searches = 1;
   */
  searches: RecentSearch[];
};

/**
 * @generated from message guardianai.v1.search.RecentSearchesResponse
 */
export type RecentSearchesResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.search.RecentSearch searches = 1;
   */
  searches?: RecentSearchJson[];
};

/**
 * Describes the message guardianai.v1.search.RecentSearchesResponse.
 * Use `create(RecentSearchesResponseSchema)` to create a new message.
 */
export const RecentSearchesResponseSchema: GenMessage<RecentSearchesResponse, {jsonType: RecentSearchesResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_search_search, 16);

/**
 * @generated from message guardianai.v1.search.RecentSearch
 */
export type RecentSearch = Message<"guardianai.v1.search.RecentSearch"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * @generated from field: int64 searched_at = 2;
   */
  searchedAt: bigint;

  /**
   * @generated from field: int32 result_count = 3;
   */
  resultCount: number;
};

/**
 * @generated from message guardianai.v1.search.RecentSearch
 */
export type RecentSearchJson = {
  /**
   * @generated from field: string query = 1;
   */
  query?: string;

  /**
   * @generated from field: int64 searched_at = 2;
   */
  searchedAt?: string;

  /**
   * @generated from field: int32 result_count = 3;
   */
  resultCount?: number;
};

/**
 * Describes the message guardianai.v1.search.RecentSearch.
 * Use `create(RecentSearchSchema)` to create a new message.
 */
export const RecentSearchSchema: GenMessage<RecentSearch, {jsonType: RecentSearchJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_search_search, 17);

/**
 * @generated from message guardianai.v1.search.SaveSearchRequest
 */
export type SaveSearchRequest = Message<"guardianai.v1.search.SaveSearchRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string query = 2;
   */
  query: string;

  /**
   * @generated from field: int32 result_count = 3;
   */
  resultCount: number;
};

/**
 * @generated from message guardianai.v1.search.SaveSearchRequest
 */
export type SaveSearchRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string query = 2;
   */
  query?: string;

  /**
   * @generated from field: int32 result_count = 3;
   */
  resultCount?: number;
};

/**
 * Describes the message guardianai.v1.search.SaveSearchRequest.
 * Use `create(SaveSearchRequestSchema)` to create a new message.
 */
export const SaveSearchRequestSchema: GenMessage<SaveSearchRequest, {jsonType: SaveSearchRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_search_search, 18);

/**
 * @generated from message guardianai.v1.search.SaveSearchResponse
 */
export type SaveSearchResponse = Message<"guardianai.v1.search.SaveSearchResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * @generated from message guardianai.v1.search.SaveSearchResponse
 */
export type SaveSearchResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;
};

/**
 * Describes the message guardianai.v1.search.SaveSearchResponse.
 * Use `create(SaveSearchResponseSchema)` to create a new message.
 */
export const SaveSearchResponseSchema: GenMessage<SaveSearchResponse, {jsonType: SaveSearchResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_search_search, 19);

/**
 * @generated from service guardianai.v1.search.SearchService
 */
export const SearchService: GenService<{
  /**
   * Global search
   *
   * @generated from rpc guardianai.v1.search.SearchService.Search
   */
  search: {
    methodKind: "unary";
    input: typeof SearchRequestSchema;
    output: typeof SearchResponseSchema;
  },
  /**
   * Alias for frontend
   *
   * @generated from rpc guardianai.v1.search.SearchService.SearchEntities
   */
  searchEntities: {
    methodKind: "unary";
    input: typeof SearchRequestSchema;
    output: typeof SearchResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.search.SearchService.SearchUsers
   */
  searchUsers: {
    methodKind: "unary";
    input: typeof SearchUsersRequestSchema;
    output: typeof SearchUsersResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.search.SearchService.SearchFraudReports
   */
  searchFraudReports: {
    methodKind: "unary";
    input: typeof SearchFraudReportsRequestSchema;
    output: typeof SearchFraudReportsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.search.SearchService.SearchEvidence
   */
  searchEvidence: {
    methodKind: "unary";
    input: typeof SearchEvidenceRequestSchema;
    output: typeof SearchEvidenceResponseSchema;
  },
  /**
   * Suggestions
   *
   * @generated from rpc guardianai.v1.search.SearchService.GetSearchSuggestions
   */
  getSearchSuggestions: {
    methodKind: "unary";
    input: typeof SuggestionRequestSchema;
    output: typeof SuggestionResponseSchema;
  },
  /**
   * Recent searches
   *
   * @generated from rpc guardianai.v1.search.SearchService.GetRecentSearches
   */
  getRecentSearches: {
    methodKind: "unary";
    input: typeof RecentSearchesRequestSchema;
    output: typeof RecentSearchesResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.search.SearchService.SaveSearch
   */
  saveSearch: {
    methodKind: "unary";
    input: typeof SaveSearchRequestSchema;
    output: typeof SaveSearchResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_search_search, 0);

